import React from 'react';
import PropTypes from 'prop-types';
import {
  groupBy,
  map,
  sortBy,
} from 'lodash';
import {
  withStyles,
  List,
  ListItemIcon,
  ListSubheader,
  ListItemText,
  ListItem,
  Icon,
  ListItemSecondaryAction,
  IconButton,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

import { getIconForView } from '../../../DashboardPage/DashboardViewSelector/defaultViews';
import { formatDateOnly } from '../../../../../utils/dateHelper';
import styles from './styles';

export const groupDashboard = (dashboards) => {
  if (dashboards.length === 0) {
    return null;
  }

  const mapppedDashboards = groupBy(dashboards.map((dashboard) => ({
    ...dashboard,
    group: dashboard.organizationExposed
      ? 'shared'
      : 'private',
  })), 'group');

  return [{
    key: 'shared',
    label: 'Shared',
    dashboards: mapppedDashboards.shared,
  }, {
    key: 'private',
    label: 'Private',
    dashboards: mapppedDashboards.private,
  }];
};

class DashboardList extends React.Component {
  handleSelectorChange = (dashboard) => {
    this.props.onDashboardChange({ ...dashboard });
  }

  render() {
    const {
      dashboards,
      selectedDashboard,
      classes,
      onDashboardDelete,
    } = this.props;

    const groups = groupDashboard(dashboards);

    return (
      <List className={classes.container}>
        {
          groups
          && groups.map((group) => (
            <div key={`dashboard-group-${group.key}`}>
              {
                group.label
                  && group.dashboards
                  && group.dashboards.length > 0
                  && (
                    <ListSubheader
                      component="div"
                      disableSticky
                      disableGutters
                      className={classes.listSubheader}
                    >
                      {group.label}
                    </ListSubheader>
                  )
              }
              {
                map(sortBy(group.dashboards, ['name']), (dashboard) => (
                  <ListItem
                    key={`dashboard-selector-${dashboard.id}`}
                    onClick={() => this.handleSelectorChange(dashboard)}
                    button
                    className={selectedDashboard.id === dashboard.id
                      ? classes.highlightItem
                      : ''}
                  >
                    <ListItemIcon>
                      <Icon>{getIconForView(dashboard.defaultView)}</Icon>
                    </ListItemIcon>
                    <ListItemText
                      primary={dashboard.name}
                      secondary={`Last updated: ${formatDateOnly(dashboard.updatedDate || dashboard.createdDate)}`}
                    />
                    <ListItemSecondaryAction>
                      <IconButton aria-label="Delete" onClick={() => onDashboardDelete(dashboard.id)}>
                        <DeleteIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))
              }
            </div>
          ))
        }
      </List>
    );
  }
}

DashboardList.propTypes = {
  dashboards: PropTypes.array,
  selectedDashboard: PropTypes.object,
  classes: PropTypes.object,
  onDashboardChange: PropTypes.func,
  onDashboardDelete: PropTypes.func,
};

DashboardList.defaultProps = {
  dashboards: [],
  selectedDashboard: {},
  classes: {},
  onDashboardChange: () => { },
  onDashboardDelete: () => { },
};

export default withStyles(styles)(DashboardList);
